export const generateSectionId = (prefix: string, id: string) => {
  return `${prefix}_${id}`
}
